import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { CurveMark } from "../../components/CarparkCurve";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const errorMsg = location.state?.error;

  if (!loading && user?.is_admin) {
    return <Navigate to="/admin" replace />;
  }

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen bg-[#0B0B0C] text-[#FAF9F6] flex flex-col" data-testid="admin-login-page">
      <div className="p-6 lg:p-10">
        <a href="/" className="inline-flex items-center gap-3 text-[#FAF9F6] hover:text-[#D8A936] transition-colors">
          <CurveMark className="w-[52px] h-[30px] text-[#FAF9F6]" />
          <span className="font-display font-extrabold text-[15px] tracking-[0.2em] uppercase">JJ Argent</span>
        </a>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md border border-[#343437] bg-[#151517] p-10 relative grain">
          <p className="eyebrow">Admin</p>
          <h1 className="mt-4 font-display text-4xl leading-tight tracking-tight">
            Sign in to{" "}<br />the console.
          </h1>
          <p className="mt-4 text-[#A9A9A6] text-sm leading-relaxed">
            Single-admin access. Sign in with your Google account. Only allowlisted emails can proceed past this step.
          </p>

          {errorMsg && (
            <div
              className="mt-6 border border-red-500/60 bg-red-500/10 text-red-300 p-4 text-sm"
              data-testid="admin-login-error"
            >
              {errorMsg}
            </div>
          )}

          <button
            type="button"
            onClick={startLogin}
            data-testid="admin-google-signin"
            className="btn-primary w-full justify-center mt-8"
          >
            <LogIn size={16} /> Continue with Google
          </button>

          <p className="mt-6 text-xs text-[#A9A9A6] leading-relaxed">
            You'll be returned to <span className="text-[#FAF9F6]">/admin</span> after signing in.
          </p>
        </div>
      </div>
    </main>
  );
}
